import { Component  } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';

@Component({
  selector: 'modalseleccion',
  templateUrl: 'modalseleccion.html'
})

export class ModalSeleccionComponent {
  public lista: any[] = [];
  public selected: any;

  constructor(private navParams: NavParams, private viewCtrl: ViewController) {
    this.lista = this.navParams.get('lista'); // Recibe los datos dinámicamente
  }

  selectValores(data) {
    this.selected = data;
    this.viewCtrl.dismiss(this.selected); // Devuelve el valores seleccionado
  }

  close() {
    this.viewCtrl.dismiss(); // Cierra el modal sin seleccionar ningún valor
  }
}



// WEBPACK FOOTER //
// ./src/components/modalseleccion/modalseleccion.ts